const digitMapping = [
  '०१२३४५६७८९', // hi, mr (Devanagari, Hindi, Marathi)
  '০১২৩৪৫৬৭৮৯', // bn (Bengali)
  '౦౧౨౩౪౫౬౭౮౯', // te (Telugu)
  '௦௧௨௩௪௫௬௭௮௯', // ta (Tamil)
  '൦൧൨൩൪൫൬൭൮൯', // ml (Malay)
  '〇一二三四五六七八九', // zh (Chinese)
];

export const normalizeDigits = (val) => {
  const digitSet = digitMapping.find((set) => set.includes(val[0]));

  return digitSet ? Array.from(val, (char) => digitSet.indexOf(char as string)).join('') : '';
};
